import { createAction,props } from '@ngrx/store';

export const loadConfigData = createAction(
  '[Planner] Load all config'
)

export const configDetails = createAction(
  '[Config details] for each page',
  props<{config_details:any}>() 
);

export const brandListing = createAction(
  '[Brand List]',
  props<{header_brands_list:any}>() 
);
